import { useEffect, useState } from "react";
import { getAccessToken } from "./accessToken";

/**
 * Resolves the current OIDC access token for use in media URLs and legacy query params.
 */
export function useAccessToken() {
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    getAccessToken().then((t) => {
      if (!cancelled) {
        setToken(t);
        setLoading(false);
      }
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return [token, loading];
}
